import type { ReduxApplicationState } from 'src/redux/combinedReducer';
import type { Facet } from 'src/redux/productsQuery/types/Facet';
import { getFacetsWithSortAsAFacet } from '../helpers/getFacetsWithSortAsAFacet';

export const selectFacetByUid = (state: ReduxApplicationState, uid: string): Facet | null => {
  return state.productsQuery.facets.find((facet) => facet.key === uid) || null;
};

export const selectFacetsWithSortAsAFacet = (state: ReduxApplicationState) => {
  return getFacetsWithSortAsAFacet(state.productsQuery.facets, state.productsQuery.sortOptions);
};

export const selectTotalActiveOptions = (state: ReduxApplicationState) => {
  return state.productsQuery.facets.reduce((total, facet) => {
    const activeOptionsCount = facet.options.filter((option) => option.active).length;

    total = total + activeOptionsCount;

    return total;
  }, 0);
};

export const selectActiveFacetUIDs = (state: ReduxApplicationState) => {
  return state.productsQuery.facets
    .filter((facet) => facet.options.some((option) => option.active))
    .map((facet) => facet.key);
};

export const selectUserActivatedFacetTitles = (state: ReduxApplicationState) => {
  const activeFacetTitles = state.productsQuery.facets.reduce((acc: string[], facet) => {
    const facetIsActive = facet.options.some((option) => option.active);

    if (facetIsActive) {
      acc.push(facet.title);
    }

    return acc;
  }, []);

  return activeFacetTitles.join(', ');
};

export const selectActiveSortOption = (state: ReduxApplicationState) => {
  return state.productsQuery.sortOptions.find((option) => option.active) || null;
};
